import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate, useLocation, Outlet } from "react-router-dom";
import { FaUserCircle, FaCog, FaLock, FaPalette, FaChevronRight } from "react-icons/fa";
import "../styles/settings.css";
const Settings = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

    // Update mobile state on window resize
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 1024);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const settingsOptions = [
        { path: "profile", icon: <FaUserCircle size={20} />, title: "Profile Settings", description: "Update your profile details" },
        { path: "general", icon: <FaCog size={20} />, title: "General Settings", description: "Manage general preferences" },
        { path: "security", icon: <FaLock size={20} />, title: "Security Settings", description: "Manage security & authentication" }
    ];

    return (
        <div className="settings-container">
            {isMobile ? (
                <div className="settings-mobile">
                    {location.pathname === "/settings" ? (
                        // ✅ Show settings list when on main settings page
                        <div className="settings-list">
                            {settingsOptions.map((setting) => (
                                <SettingNavItem
                                    key={setting.path}
                                    icon={setting.icon}
                                    title={setting.title}
                                    description={setting.description}
                                    onClick={() => navigate(`/settings/${setting.path}`)}
                                />
                            ))}
                        </div>
                    ) : (
                        // ✅ Show selected setting content dynamically via Outlet
                        <div className="settings-content">
                            <Outlet />
                        </div>
                    )}
                </div>
            ) : (
                // Desktop View
                <>
                    <div className="settings-sidebar">
                        <div className="settings-list">
                            {settingsOptions.map((setting) => (
                                <SettingNavItem
                                    key={setting.path}
                                    icon={setting.icon}
                                    title={setting.title}
                                    description={setting.description}
                                    onClick={() => navigate(`/settings/${setting.path}`)}
                                />
                            ))}
                        </div>
                    </div>
                    <div className="settings-content">
                        <Outlet />
                    </div>
                </>
            )}
        </div>
    );
};

// Sidebar Navigation Item
const SettingNavItem = ({ icon, title, description, onClick }) => (
    <div className="setting-item" onClick={onClick}>
        <div className="setting-left">
            {icon}
            <div className="setting-text">
                <strong>{title}</strong>
                <span>{description}</span>
            </div>
        </div>
    </div>
);

export default Settings;
